module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    attrs: {
      "name": "header"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-view', {
    attrs: {
      "name": "side"
    }
  }), _vm._v(" "), _c('router-view', {
    staticClass: "main",
    attrs: {
      "name": "main"
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-625d4848","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 486
// module chunks = 1